<template>
    <div>
        <!-- 搜索结果 -->
        <search-field :field="search_field" />

        <a-form-model :model="form" class="ad-search" v-if="visible">
            <a-row :gutter="24">
                <a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" :xxl="4">
                    <a-form-model-item label="姓名">
                        <a-input v-model="form.name" />
                    </a-form-model-item> </a-col
                ><a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" :xxl="4">
                    <a-form-model-item label="手机号码">
                        <a-input v-model="form.mobile" />
                    </a-form-model-item> </a-col
                ><a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" :xxl="4">
                    <a-form-model-item label="微信号">
                        <a-input v-model="form.wechat_id" />
                    </a-form-model-item> </a-col
                ><a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" :xxl="4">
                    <a-form-model-item label="QQ">
                        <a-input v-model="form.qq" />
                    </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" :xxl="4">
                    <a-form-model-item label="地区">
                        <a-cascader
                                :options="option_area"
                                placeholder="选择地址"
                                @change="on_area_select"
                                v-model ="array_area"
                        />
                    </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" :xxl="4">
                    <a-form-model-item label="公司名称">
                        <a-input v-model="form.com_name" />
                    </a-form-model-item>
                </a-col>

                <a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" :xxl="4">
                    <a-form-model-item label="备注">
                        <a-input v-model="form.remark" />
                    </a-form-model-item>
                </a-col>

                <a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" :xxl="4">
                    <a-form-model-item label="余额">
                        <a-input-group compact>
                            <a-input-number style=" width: 40%; text-align: center" placeholder="大于" v-model="form.balance_gte" />
                            <a-input
                                style=" width: 20%; border-left: 0; pointer-events: none; backgroundColor: #fff"
                                placeholder="~"
                                disabled
                            />
                            <a-input-number
                                style="width: 40%; text-align: center; border-left: 0"
                                placeholder="小于"
                                v-model="form.balance_lte"
                            />
                        </a-input-group>
                    </a-form-model-item>
                </a-col>

                <!-- <a-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" :xxl="4">
                    <a-form-model-item label="总消费">
                        <a-input-group compact>
                            <a-input-number style=" width: 40%; text-align: center" placeholder="大于" v-model="form.expense_gte" />
                            <a-input
                                style=" width: 20%; border-left: 0; pointer-events: none; backgroundColor: #fff"
                                placeholder="~"
                                disabled
                            />
                            <a-input-number
                                style="width: 40%; text-align: center; border-left: 0"
                                placeholder="小于"
                                v-model="form.expense_lte"
                            />
                        </a-input-group>
                    </a-form-model-item> </a-col
                > -->

                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8" :xxl="8">
                    <a-row :gutter="12">
                        <a-col :span="12">
                            <a-form-model-item label="录入时间早于">
                                <a-date-picker v-model="form.created_at_gte" valueFormat="YYYY-MM-DD 00:00:00" style="width:100%;" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="录入时间晚于">
                                <a-date-picker v-model="form.created_at_lte" valueFormat="YYYY-MM-DD 23:59:59" style="width:100%;" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>

            <div class="action">
                <a-button type="primary" @click="on_ok" icon="search">
                    搜索
                </a-button>
                <a-button @click="on_reset" icon="rollback">重置</a-button>
                <a-button type="dashed" @click="on_cancel" icon="close">
                    关闭搜索面板
                </a-button>
            </div>
        </a-form-model>
    </div>
</template>
<script>
    // import basic_data from "../../mixins/basic_data";
    import area from "../../../mixins/area";

    let search_field = {
        wd: "模糊搜索",
        member_id: "客户编号",
        name: "姓名",
        com_name: "姓名",
        project_id: "项目",
        qq: "QQ",
        wechat_id: "微信号",
        mobile: "手机号码",
        balance_gte: "余额大于",
        balance_lte: "余额小于",
        created_at_gte: "录入晚于",
        created_at_lte: "录入早于",
        remark: "备注",
        member_area: "客户区域",
        // user_id: "销售",
    };

    export default {
        props: {
            visible: false,
            callback: null,
            path: null,
        },
        data() {
            return {
                form: {},
                search_field: search_field,
                submitting: false,
                option_area: area,
                array_area: [],
            };
        },
        created() {
            var obj = {};
            Object.keys(search_field).map((v) => {
                obj[v] = null;
            });
            this.form = obj; //JSON.parse(JSON.stringify(init_form));
        },
        mounted() {},
        watch: {
            visible(v) {
                if (v) {
                    let query = this.$route.query;
                    Object.keys(this.form).map((v) => {
                        if (Object.prototype.hasOwnProperty.call(query, v)) {
                            switch (v) {
                                case "source_id":
                                case "project_id":
                                    this.form[v] = query[v].split(",");
                                    break;
                                case "member_area":
                                    this.array_area = query[v].split("/");
                                    break;
                                default:
                                    this.form[v] = query[v];
                            }
                        } else {
                            this.form[v] = null;
                            this.array_area = [];
                        }
                    });
                }
            },
        },
        methods: {
            on_ok() {
                let query = JSON.parse(JSON.stringify(this.form));
                let query2 = JSON.parse(JSON.stringify(this.$route.query));
                query2['page'] = 0;

                let query3 = { ...query, ...query2 };

                Object.keys(query3).map((v) => {
                    if (query3[v] == null || query3[v] == "") {
                        delete query3[v];
                    }
                });

                this.$router.push(`${this.path}?${this.objectToQuery(query3)}`);
            },
            on_reset() {
                this.$router.push(this.path);
                this.array_area = [];
            },
            on_cancel() {
                this.$emit("close");
            },
            on_area_select(value){
                this.form.member_area = value.join("/")
            },
        },
    };
</script>

<style lang="less" scoped>
    .ad-search {
        padding: 16px;
        background-color: #f0f8ff;
        border-bottom: 1px solid #e8e8e8;
        .ant-form-item {
            margin-bottom: 8px;
        }
        .action {
            margin-top: 8px;
            .ant-btn {
                margin-right: 8px;
            }
        }
    }
</style>
